// THIS FILE IS AUTOGENERATED

export interface Version {
  commit: string;
  version: string;
  app: string;
}

export const version = {
  app: "myqq",
  commit: "b84d7b53f873c5ac6af67a45d293c2cbe23df584",
  version: "1.125.0",
};
